export const INTEREST_BANK_SIZE = 120;
export const INTEREST_ATTEMPT_SIZE = 40;

/**
 * @param {string} questionId
 * @returns {number | null}
 */
export function bankIndexFromQuestionId(questionId) {
  const m = /^sit_(\d+)$/.exec(String(questionId || '').trim());
  if (!m) return null;
  const n = Number(m[1]);
  if (!Number.isFinite(n) || n < 1 || n > INTEREST_BANK_SIZE) return null;
  return n - 1;
}

/**
 * Uniform random sample — legacy fallback only; production uses POST /api/interest-test/draw.
 * @param {string[]} questionIds
 * @param {number} count
 */
export function pickRandomInterestQuestionIds(questionIds, count = INTEREST_ATTEMPT_SIZE) {
  const pool = Array.isArray(questionIds) ? [...questionIds] : [];
  if (pool.length < count) {
    throw new Error(`Need at least ${count} questions, got ${pool.length}`);
  }
  for (let i = pool.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, count);
}

/**
 * @param {Array<{ question: { id: string } }>} allItems
 * @param {string[]} selectedIds
 */
export function filterInterestSessionItems(allItems, selectedIds) {
  if (!Array.isArray(selectedIds) || !selectedIds.length) return [];
  const byId = new Map(
    (Array.isArray(allItems) ? allItems : []).map((item) => [item.question.id, item])
  );
  return selectedIds.map((id) => byId.get(id)).filter(Boolean);
}
